import { type ProductData } from "../models/ProductData";

import { transformProduct } from "../ProductDetails/transformers/ProductDataTransformer";
import { type ProductDataDTO } from "../dto/ProductDataDTO";
import { resolveApiUrl } from "../utils/url/urlResolver";
import { transformPdpProduct } from "~/ProductDetails/transformers/PdpPageProductDataTransformer";
import { type PdpPageProductDataDto } from "~/ProductDetails/dto/PdpPageProductDataDto";

export async function fetchProductInfo(productCode: string, details?: boolean): Promise<ProductData> {
  const url = resolveApiUrl(`/p/api/${productCode}?details=${details ? "true" : "false"}`);
  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (!response.ok) {
    throw new Error("Error fetching product");
  }
  const dto = (await response.json()) as ProductDataDTO;
  const product = details ? transformPdpProduct(dto as PdpPageProductDataDto, null) : transformProduct(dto);
  product.isFullProduct = true;
  return product;
}
